import { render, staticRenderFns } from "./searchSelect.vue?vue&type=template&id=28bfca48&scoped=true"
import script from "./searchSelect.vue?vue&type=script&lang=js"
export * from "./searchSelect.vue?vue&type=script&lang=js"
import style0 from "./searchSelect.vue?vue&type=style&index=0&id=28bfca48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfca48",
  null
  
)

export default component.exports